export default __webpack_public_path__ + "static/montserrat-v26-latin-ext-500-460e0a49408ef798457c17122ff793e5.woff2";